import { Image } from "antd";
import { FC, useCallback } from "react";

import {
    StyledAPContractTableFile,
    StyledAPContractTableFileIcon,
    StyledAPContractTableFileName,
} from "@/pages/WorkPlan/AboutPoint/Styled";
import { BaseModal } from "@/shared/ui/BaseModal";
import { getFileUrl } from "@/utils/file/getFileUrl";
import { handleDownloadFile } from "@/utils/file/handleDownloadFile";

interface TaskInfoModalProps {
    onCloseModal: () => void;
    title: string;
    description: string;
    files?: string[];
}

const IMAGE_EXTENSIONS = ["jpg", "jpeg", "png", "gif", "bmp", "webp", "svg"];

const isImageFile = (fileName: string): boolean => {
    const extension = fileName.split(".").pop()?.toLowerCase();
    return extension ? IMAGE_EXTENSIONS.includes(extension) : false;
};

export const TaskInfoModal: FC<TaskInfoModalProps> = ({
    onCloseModal,
    title,
    description,
    files,
}) => {
    const handleFileClick = useCallback((file: string) => {
        const fileName = file.split("/").pop() || "document";
        handleDownloadFile(getFileUrl(file), fileName.replace(/\..+$/, ""));
    }, []);

    const imageFiles = files?.filter((file) => isImageFile(file)) || [];
    const otherFiles = files?.filter((file) => !isImageFile(file)) || [];

    return (
        <BaseModal
            open
            onClose={onCloseModal}
            title={title}
            description={description}
            mask={{ closable: true }}
            actions={null}
        >
            {imageFiles.length > 0 && (
                <div style={{ marginBottom: 16 }}>
                    <Image.PreviewGroup>
                        <div
                            style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(3, 1fr)",
                                gap: 8,
                            }}
                        >
                            {imageFiles.map((file) => (
                                <Image
                                    key={file}
                                    src={getFileUrl(file)}
                                    alt={file.split("/").pop()}
                                    style={{
                                        width: "100%",
                                        aspectRatio: "1/1",
                                        objectFit: "cover",
                                        borderRadius: 4,
                                    }}
                                />
                            ))}
                        </div>
                    </Image.PreviewGroup>
                </div>
            )}

            {otherFiles.length > 0 &&
                otherFiles.map((file) => {
                    const fileName = file.split("/").pop()!;
                    return (
                        <StyledAPContractTableFile
                            key={file}
                            onClick={() => handleFileClick(file)}
                        >
                            <StyledAPContractTableFileIcon />
                            <StyledAPContractTableFileName>
                                {fileName}
                            </StyledAPContractTableFileName>
                        </StyledAPContractTableFile>
                    );
                })}
        </BaseModal>
    );
};
